var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "briefs-list-pane" },
    [
      _c("SelectFolderModalToolbar", {
        attrs: { value: _vm.searchKey, placeholder: "Search briefs..." },
        on: {
          input: function ($event) {
            _vm.searchKey = $event
          },
          clear: function ($event) {
            _vm.searchKey = ""
          },
        },
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "briefs-list-pane__state" },
            [_c("b-spinner")],
            1
          )
        : _vm.loadFailed
        ? _c("div", { staticClass: "briefs-list-pane__state" }, [
            _vm._v("\n    Could not load your briefs.\n  "),
          ])
        : _vm.visibleBriefs.length === 0
        ? _c("div", { staticClass: "briefs-list-pane__state" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.searchKey.trim()
                    ? "No briefs match your search."
                    : "No briefs found."
                ) +
                "\n  "
            ),
          ])
        : _c(
            "div",
            { staticClass: "briefs-list-pane__list" },
            _vm._l(_vm.visibleBriefs, function (brief) {
              return _c(
                "button",
                {
                  key: brief.id,
                  staticClass: "briefs-list-pane__row",
                  class: {
                    "briefs-list-pane__row--static": brief.isPendingIntake,
                    "briefs-list-pane__row--selected":
                      _vm.selectable &&
                      String(_vm.selectedId) === String(brief.id),
                  },
                  attrs: {
                    type: "button",
                    title: brief.isPendingIntake
                      ? "Pending intake — not yet a brief you can browse"
                      : null,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onRowClick(brief)
                    },
                  },
                },
                [
                  _c("FileTextIcon", {
                    staticClass: "briefs-list-pane__row-icon",
                    attrs: { width: 16, height: 16 },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "briefs-list-pane__row-body" }, [
                    _c("span", { staticClass: "briefs-list-pane__row-title" }, [
                      _vm._v(_vm._s(brief.title)),
                    ]),
                    _vm._v(" "),
                    _vm.showOwnerSubtitle
                      ? _c(
                          "span",
                          { staticClass: "briefs-list-pane__row-subtitle" },
                          [_vm._v(_vm._s(brief.subtitle))]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  !_vm.showOwnerSubtitle
                    ? _c(
                        "span",
                        { staticClass: "briefs-list-pane__row-updated" },
                        [_vm._v("Updated " + _vm._s(brief.updatedAgo))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !brief.isPendingIntake
                    ? _c("b-icon", {
                        staticClass: "briefs-list-pane__row-chevron",
                        attrs: { icon: "chevron-right" },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }